// AWS Service for Lambda invocation via Function URL

// AWS Configuration
const AWS_CONFIG = {
  region: 'ap-south-1'
};

export class AWSService {
  constructor() {
    this.region = AWS_CONFIG.region;
  }

  /**
   * Invoke the deployment Lambda function directly with 10-minute timeout
   */
  async invokeDeploymentLambda(config, environment = 'prod') {
    // Use the Lambda Function URL directly since CloudFront routing is having issues
    const lambdaUrl = 'https://stqkox4ly7wfqkfqv3kstxalhy0czjwu.lambda-url.ap-south-1.on.aws/';
    
    try {
      console.log('Invoking Lambda Function URL directly:', lambdaUrl);
      console.log('Payload:', { config, environment });
      
      // Create AbortController for 10-minute timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10 * 60 * 1000); // 10 minutes
      
      const response = await fetch(lambdaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          config: config,
          environment: environment
        }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      const responseText = await response.text();
      console.log('Lambda response:', responseText);

      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        result = { message: responseText };
      }

      // Handle Lambda Function URL response format
      if (result.statusCode) {
        // This is a Lambda Function URL response with statusCode, headers, body
        const lambdaSuccess = result.statusCode >= 200 && result.statusCode < 300;
        let parsedBody;
        
        try {
          parsedBody = typeof result.body === 'string' ? JSON.parse(result.body) : result.body;
        } catch (parseError) {
          parsedBody = { message: result.body };
        }

        if (!lambdaSuccess) {
          throw new Error(`Lambda Error ${result.statusCode}: ${parsedBody.error || JSON.stringify(parsedBody)}`);
        }

        return {
          statusCode: result.statusCode,
          success: lambdaSuccess,
          requestId: response.headers.get('x-amzn-requestid') || 'unknown',
          response: parsedBody
        };
      } else {
        // This is a regular HTTP response
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText} - ${responseText}`);
        }

        return {
          statusCode: response.status,
          success: response.ok,
          requestId: result.requestId || response.headers.get('x-amzn-requestid') || 'unknown',
          response: result
        };
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('Lambda invocation timed out after 10 minutes');
        throw new Error('Lambda invocation timed out after 10 minutes');
      }
      console.error('Error calling Lambda Function URL:', error);
      throw error;
    }
  }

}

const awsServiceInstance = new AWSService();
export default awsServiceInstance;